/**
 * The order programs are shown in, everywhere a person sees them listed.
 *
 * Alphabetical (LA, SI, TA) so the interface never appears to rank one
 * program ahead of another: each program is autonomous, and a fixed
 * SI-first order quietly suggested otherwise.
 *
 * Display only. Two other orderings exist on purpose and must not read
 * from here: PROGRAM_WINDOW_ORDER (deadline.js) is the timeline-first
 * routing order, and COORDINATOR_PROGRAMS (coordinatorRole.js) mirrors the
 * server's coordinator-role scan order.
 */
export const PROGRAM_DISPLAY_ORDER = ['la', 'si', 'ta'];

/**
 * A copy of `items` sorted into PROGRAM_DISPLAY_ORDER. Items whose key is
 * not a known program keep their relative order, after the known ones.
 *
 * @template T
 * @param {T[]} items
 * @param {(item: T) => string} [keyOf] reads the program key ('si' etc.)
 * @returns {T[]}
 */
export function inProgramDisplayOrder(items, keyOf = (item) => item.key) {
    const rank = (item) => {
        const index = PROGRAM_DISPLAY_ORDER.indexOf(keyOf(item));
        return index === -1 ? PROGRAM_DISPLAY_ORDER.length : index;
    };
    return [...items].sort((a, b) => rank(a) - rank(b));
}
